import React from 'react';
import { Box, Typography } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

// Same look as the "Volver a Ubicación" link on the POS page
const BackToAlertsLink = ({ onClick, sx }) => {
  const { t } = useTranslation();

  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        p: 0,
        border: 0,
        background: 'none',
        cursor: 'pointer',
        color: '#6B46C1',
        '&:hover': {
          color: '#553C9A',
          textDecoration: 'underline'
        },
        ...sx
      }}
    >
      <ArrowBackIcon sx={{ fontSize: 18 }} />
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 500 }}>
        {t('back_to_alerts')}
      </Typography>
    </Box>
  );
};

export default BackToAlertsLink;
